import React from 'react'
import PropTypes from 'prop-types'

import { NavLink as Link } from 'react-router-dom'

import {
  Nav,
  NavLink,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'

import Button from './../../../../ui/Button'

import userAuthRoutes from '../../../../setup/routes/user-auth'
import adminRoutes from '../../../../setup/routes/admin'
import userRoutes from '../../../../setup/routes/user'

import userIcon from './../images/user.svg'

const SearchForm = adminRoutes.userFilter.component
const Login = userAuthRoutes.login.component
const Logout = userAuthRoutes.logout.component

const MyAccount = ({ isAuthenticated, isSuperAdmin, isAdmin, isGuide, isUser, avatarImg, onClickNavLink=f=>f }) => (
  <Nav className="mr" navbar>
    <NavItem className={ "my-auto " + (isAuthenticated && "d-none") }>
      <NavLink onClick={ onClickNavLink } tag={Link} to={userAuthRoutes.signup.path}>S'inscrire</NavLink>
    </NavItem>
    <NavItem className={ " " + (isAuthenticated && "d-none") }>
      <Login><Button color="secondary">Se Connecter</Button></Login>
    </NavItem>
    { (isAuthenticated && (isSuperAdmin || isAdmin || isGuide)) && <SearchForm onSubmit={ onClickNavLink } /> }

    { /* On mobile */ }
    { isAuthenticated &&
      <>
        <NavItem className="d-block d-lg-none d-xl-none">
          { isUser && <>
            <NavLink onClick={ onClickNavLink } tag={ Link } to={ userRoutes.myAccount.path }>
              Mon compte
            </NavLink>
          </>}
          { (isSuperAdmin || isAdmin || isGuide) && <>
            <NavLink onClick={ onClickNavLink } tag={ Link } to={ adminRoutes.myProfile.path }>
              Mon compte
            </NavLink>
          </>}
          <Logout>
            <NavLink onClick={ onClickNavLink }>
              Se déconnecter
            </NavLink>
          </Logout>
        </NavItem>
      </>
    }
    { /* on PC and tablet */ }
    { isAuthenticated &&
      <UncontrolledDropdown className="d-none d-lg-block d-xl-block" nav inNavbar>
        <DropdownToggle nav>
          <span className="user-avatar" style={{ backgroundImage: `url(${ avatarImg ? avatarImg : userIcon})` }} />
        </DropdownToggle>
        <DropdownMenu right>
          { (isSuperAdmin || isAdmin || isGuide) && <>
            <DropdownItem>
              <NavLink className="p-0 text-left" tag={ Link } to={ adminRoutes.myProfile.path }>
                Mon compte
              </NavLink>
            </DropdownItem>
          </>
          }
          { isUser && <>
            <DropdownItem>
              <NavLink className="p-0 text-left" tag={ Link } to={ userRoutes.myAccount.path }>
                Mon compte
              </NavLink>
            </DropdownItem>
            <DropdownItem>
              <NavLink className="p-0 text-left" tag={ Link } to={ userRoutes.myActivities.path }>
                Mes activités
              </NavLink>
            </DropdownItem>
            <DropdownItem>
              <NavLink className="p-0 text-left" tag={ Link } to={ userRoutes.myAppointments.path }>
                Mes rendez-vous
              </NavLink>
            </DropdownItem>
          </>
          }
          <DropdownItem divider />
          <Logout>
            <DropdownItem>
              Se déconnecter
            </DropdownItem>
          </Logout>
        </DropdownMenu>
      </UncontrolledDropdown>
    }
  </Nav>
)


MyAccount.propTypes = {
  isAuthenticated: PropTypes.bool,
  isAdmin: PropTypes.bool,
  isGuide: PropTypes.bool,
  isUser: PropTypes.bool,
  isSuperAdmin: PropTypes.bool,
  avatar: PropTypes.string
}


export default MyAccount
